export enum actionTypes {
  TIPOS_ESTUDIO_FETCH = 'TIPOS_ESTUDIO_FETCH',
  TIPOS_ESTUDIO_SUCCESS = 'TIPOS_ESTUDIO_SUCCESS',
  TIPOS_ESTUDIO_ERROR = 'TIPOS_ESTUDIO_ERROR',
  TIPOS_ESTUDIO_RESET = 'TIPOS_ESTUDIO_RESET',
}

export enum TiposEstudioStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface TipoEstudio {
  id: number
  nombre: string
}

export interface TiposEstudioState {
  idPais?: number
  status: TiposEstudioStatus
  tiposEstudio: Array<TipoEstudio>
}

export interface TiposEstudioFetch {
  type: typeof actionTypes.TIPOS_ESTUDIO_FETCH
  payload: { idPais }
}

export interface TiposEstudioSuccess {
  type: typeof actionTypes.TIPOS_ESTUDIO_SUCCESS
  payload: { tiposEstudio }
}

export interface TiposEstudioError {
  type: typeof actionTypes.TIPOS_ESTUDIO_ERROR
  payload: null
}

export interface TiposEstudioReset {
  type: typeof actionTypes.TIPOS_ESTUDIO_RESET
  payload: null
}

export type TiposEstudioActions = TiposEstudioFetch | TiposEstudioSuccess | TiposEstudioError | TiposEstudioReset

export const initialState: TiposEstudioState = {
  status: TiposEstudioStatus.Idle,
  tiposEstudio: [],
}
